import {defineMessages} from 'react-intl';

export default defineMessages({
	refundMethod: {
		id: 'returnAuthCreateForm.step2.refundMethod',
		defaultMessage: 'Refund method',
	},
	storeCreditLabel: {
		id: 'returnAuthCreateForm.step2.storeCreditLabel',
		defaultMessage: 'Store credit',
	},
	giftCertificateLabel: {
		id: 'returnAuthCreateForm.step2.giftCertificateLabel',
		defaultMessage: 'Gift Certificate',
	},
	modifyButtonText: {
		id: 'returnAuthCreateForm.step2.modifyButtonText',
		defaultMessage: 'Modify',
	},
});
